/** CoStar.Api.AptsReviews.ViewModels.Import.ImportReviewStatus */
export var ImportReviewStatus;
(function (ImportReviewStatus) {
    ImportReviewStatus[ImportReviewStatus["None"] = 0] = "None";
    ImportReviewStatus[ImportReviewStatus["Imported"] = 1] = "Imported";
    ImportReviewStatus[ImportReviewStatus["ListingFound"] = 2] = "ListingFound";
    ImportReviewStatus[ImportReviewStatus["ListingNotFound"] = 3] = "ListingNotFound";
    ImportReviewStatus[ImportReviewStatus["MovingToReview"] = 4] = "MovingToReview";
    ImportReviewStatus[ImportReviewStatus["MovedToReview"] = 5] = "MovedToReview";
    ImportReviewStatus[ImportReviewStatus["ParseError"] = 6] = "ParseError";
})(ImportReviewStatus || (ImportReviewStatus = {}));
